<template>
    <div id="zero__layout" class="zero__layout">
        <div class="bcw">
            <div class="zero__header">
                <span>
                    <img src="/images/icon_parcels_black.svg">
                </span>
                <p class="title">{{ trans('dashboard_distrib.empty') }}</p>
                <p class="subtitle">{{ trans('dashboard_distrib.empty_tease') }}</p>
            </div>
            <div class="zero__ctas">
                <a href="/biomemakers-subclients" class="cta__add-client">
                    <div class="bc__cta">
                        <bcw-button></bcw-button>
                    </div>
                    <img src="images/newsc.svg" alt="">
                    <p class="title">{{ trans('dashboard_distrib.add_sub.title') }}</p>
                    <p class="subtitle">{{ trans('dashboard_distrib.add_sub.sub') }}</p>
                </a>
                <div class="cta__rest">
                    <a href="/orders?newrequest=true" class="cta cta__analysis">
                        <div class="bc__cta">
                            <bcw-button></bcw-button>
                        </div>
                        <img src="images/samp.svg">
                        <div class="desc">
                            <p class="title">{{ trans('dashboard_distrib.add_fc.title') }}</p>
                            <p class="subtitle">{{ trans('dashboard_distrib.add_fc.sub') }} </p>
                        </div>
                    </a>
                    <a href="/map?new" class="cta cta__parcel">
                        <div class="bc__cta">
                            <bcw-button></bcw-button>
                        </div>
                        <img src="/crop/pic/background/grape" class="card__logo">
                        <div class="desc">
                            <p class="title">{{ trans('dashboard_distrib.add_parcel.title') }}</p>
                            <p class="subtitle">{{ trans('dashboard_distrib.add_parcel.sub') }}</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    props: {
    },

    data() {
        return {

        };
    },

    mounted() {
    },

    methods: {
    }

};

</script>
